/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на создание валютного контрагента
 */
export interface CurrencyPaymentDetailsCreateRequest {
  /** Контрагент */
  contractor?: CurrencyPaymentDetailsCreateUpdateRequestContractor;
  account?: string;
  contractorBankName?: string;
  swift?: string;
  contractorBankCountry?: string;
  contractorBankCity?: string;
  contractorBankAddress?: string;
  clirCode?: string;
  agentBankAccount?: string;
  agentBankName?: string;
  agentBankAddress?: string;
  agentBankCountry?: string;
  agentBankCity?: string;
  agentClirCode?: string;
  agentSwift?: string;

  /** @format int64 */
  monolithId?: number;
}

/**
 * Контрагент
 */
export interface CurrencyPaymentDetailsCreateUpdateRequestContractor {
  organizationName?: string;
  countryCode?: string;
  inn?: string;
  address?: string;
  city?: string;
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /**
   * Дата и время
   * @format date-time
   */
  timestamp?: string;
}

/**
 * Ответ для справочника контрагентов
 */
export interface ContractorResponse {
  /** @format uuid */
  id?: string;
  organizationName?: string;
  organizationType?: string;

  /** Cтрана */
  country?: Country;

  /** @format uuid */
  clientId?: string;
  inn?: string;
  kpp?: string;
  address?: string;
  city?: string;
}

/**
 * Cтрана
 */
export interface Country {
  /** @format uuid */
  id?: string;
  code?: string;
  name?: string;
  nameLat?: string;
  twoLetterCode?: string;
}

/**
 * Ответ для справочника валютных реквизитов.
 */
export interface CurrencyPaymentDetailsResponse {
  /** @format uuid */
  id?: string;

  /** Ответ для справочника контрагентов */
  contractor?: ContractorResponse;
  account?: string;
  contractorBankName?: string;
  swift?: string;

  /** Cтрана */
  contractorBankCountry?: Country;
  contractorBankCity?: string;
  contractorBankAddress?: string;
  clirCode?: string;
  agentBankAccount?: string;
  agentBankName?: string;
  agentBankAddress?: string;

  /** Cтрана */
  agentBankCountry?: Country;
  agentBankSwift?: string;
  agentBankCity?: string;
  agentClirCode?: string;

  /** @format int64 */
  monolithId?: number;

  /** @format date-time */
  createDate?: string;
}

/**
 * Контрагент
 */
export interface Contractor {
  organizationName?: string;
  organizationType?: string;
  countryCode?: string;

  /** @format int64 */
  clientExtId?: number;
  inn?: string;
  kpp?: string;
  address?: string;
  city?: string;
}

/**
 * Ответ на запрос получения списка рублевых рублевых реквизитов
 */
export interface RublePaymentDetailsListResponse {
  hasMore: boolean;
  data: RublePaymentDetailsResponse[];
}

/**
 * Запрос рублевого реквизита контрагента
 */
export interface RublePaymentDetailsRequest {
  /**
   * Идентификатор контрагента мигрированного из монолита
   * @format int64
   */
  legacyId?: number;

  /** Наименование контрагента */
  name?: string;

  /** ИНН контрагента */
  inn?: string;

  /** КПП контрагента */
  kpp?: string;

  /** Счет рублевого реквизита контрагента */
  accountNumber?: string;

  /** Банк рублевого реквизита контрагента */
  bankName?: string;

  /** БИК банка рублевого реквизита контрагента */
  bankBic?: string;

  /** Корр.счет банка рублевого реквизита контрагента */
  bankCorAccount?: string;

  /** Тип населенного пункта банка контрагента */
  bankPlaceType?: string;

  /** Наименование населенного пункта банка контрагента */
  bankPlaceName?: string;

  /** Идентификатор клиента в ABS */
  absClientId?: string;

  /** Филиал клиента */
  branchId?: string;
}

/**
 * Банк
 */
export interface Bank {
  /** Наименование банка */
  name: string;

  /** Бик банка */
  bic: string;

  /** Корр. счет банка */
  corAccount: string;

  /** Тип населенного пункта банка контрагента */
  placetype?: string;

  /** Наименование населенного пункта банка контрагента */
  placename?: string;
}

/**
 * Ответ рублевого реквизита контрагента
 */
export interface RublePaymentDetailsResponse {
  /**
   * Идентификатор контрагента
   * @format uuid
   */
  id: string;

  /** ИНН контрагента */
  inn: string;

  /** КПП контрагента */
  kpp?: string;

  /** Наименование контрагента */
  name: string;

  /** Адрес контрагента */
  address?: string;

  /** Телефон контрагента */
  phone?: string;

  /** Счет рублевого реквизита контрагента */
  accountNumber: string;

  /** Банк */
  bank: Bank;
}

/**
 * Информация по одному валютному реквизиту в запросе по списку валютных реквизитов
 */
export interface CurrencyPaymentDetailsDataResponse {
  /** @format uuid */
  id?: string;

  /** Ответ для справочника контрагентов */
  contractor?: ContractorResponse;
  account?: string;
  contractorBankName?: string;
  swift?: string;

  /** Cтрана */
  contractorBankCountry?: Country;
  contractorBankCity?: string;
  contractorBankAddress?: string;
}

/**
 * Ответ для получения списка валютых реквизитов
 */
export interface CurrencyPaymentDetailsListResponse {
  hasMore?: boolean;
  data?: CurrencyPaymentDetailsDataResponse[];
}

/**
 * Данные контрагента
 */
export interface Contragent {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  responsibleId?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;

  /** @format uuid */
  prefCommnMethodId?: string;
  prefCommnMethodName?: string;
  fullCompanyName?: string;
  fullName?: string;
  inn?: string;
  phone?: string;
  email?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  updateDate?: string;
}

/**
 * Страница с данными о контрагентах
 */
export interface ContragentPage {
  data?: Contragent[];

  /** Пагинация */
  page?: PaginationInfo;
}

/**
 * Пагинация
 */
export interface PaginationInfo {
  /** @format int64 */
  size?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int64 */
  totalPages?: number;

  /** @format int64 */
  number?: number;
}

/**
 * Тип контрагента
 */
export interface ContragentType {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Предпочитаемый способов связи контрагента
 */
export interface ContragentPrefCommnMethod {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Счет
 */
export interface AccountResponse {
  number?: string;
  currency?: string;
}

/**
 * Детализированный ответ для справочника контрагентов
 */
export interface ContractorDetailedResponse {
  /** @format uuid */
  id?: string;
  organizationName?: string;
  organizationType?: string;

  /** Cтрана */
  country?: Country;

  /** @format uuid */
  clientId?: string;
  inn?: string;
  kpp?: string;
  address?: string;
  city?: string;
  currencyPaymentDetails?: CurrencyPaymentDetailsWithoutContractorResponse[];
  rublePaymentsDetailsResponse?: RublePaymentsDetailsWithoutContractorResponse[];
}

/**
 * Ответ для справочника рублевых реквизитов без контрагента
 */
export interface CurrencyPaymentDetailsWithoutContractorResponse {
  /** @format uuid */
  id?: string;

  /** Счет */
  account?: AccountResponse;
  contractorBankName?: string;
  swift?: string;

  /** Cтрана */
  contractorBankCountry?: Country;
  contractorBankCity?: string;
  contractorBankAddress?: string;
  clirCode?: string;
  agentBankAccount?: string;
  agentBankName?: string;
  agentBankAddress?: string;

  /** Cтрана */
  agentBankCountry?: Country;
  agentBankSwift?: string;
  agentBankCity?: string;
  agentClirCode?: string;

  /** @format int64 */
  monolithId?: number;
}

/**
 * Ответ для справочника рублевых реквизитов без контрагента
 */
export interface RublePaymentsDetailsWithoutContractorResponse {
  bic?: string;
  corrAccount?: string;
  bank?: string;
  accountNumber?: string;
}

/**
 * Ответ для справочника контрагентов со списком счетов
 */
export interface ContractorWithAccountsResponse {
  /** @format uuid */
  id?: string;
  organizationName?: string;
  organizationType?: string;

  /** Cтрана */
  country?: Country;

  /** @format uuid */
  clientId?: string;
  inn?: string;
  kpp?: string;
  address?: string;
  city?: string;
  currencyAccounts?: string[];
  rubleAccounts?: string[];
}

/**
 * Делегат клиента
 */
export interface ClientDelegate {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  orgId?: string;
  userRefId?: string;
  cioId?: string;
  fullName?: string;
  isNotActive?: boolean;
}

/**
 * Ответ с данными о делегатах клиента
 */
export interface ClientDelegateData {
  data?: ClientDelegate[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-contractors
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-contractors.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, ВЭД <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name GetCurrencyDetails
     * @summary Получение валютных реквизитов по ид
     * @request GET:/api/contractors/v1/external/currency
     * @secure
     */
    getCurrencyDetails: (query: { uuid: string }, params: RequestParams = {}) =>
      this.request<CurrencyPaymentDetailsResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/currency`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name PutCurrencyDetails
     * @summary Редактирование валютных реквизитов
     * @request PUT:/api/contractors/v1/external/currency
     * @secure
     */
    putCurrencyDetails: (
      query: { detailsId: string },
      data: CurrencyPaymentDetailsCreateRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyPaymentDetailsResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/currency`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name PostCurrencyDetails
     * @summary Сохранение валютных реквизитов
     * @request POST:/api/contractors/v1/external/currency
     * @secure
     */
    postCurrencyDetails: (
      data: CurrencyPaymentDetailsCreateRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyPaymentDetailsResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/currency`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name DeleteCurrencyDetails
     * @summary Удаление валютных реквизитов
     * @request DELETE:/api/contractors/v1/external/currency
     * @secure
     */
    deleteCurrencyDetails: (
      query: { uuid: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/contractors/v1/external/currency`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name GetContractorById
     * @summary Получение контрагента по ид
     * @request GET:/api/contractors/v1/external/contractors
     * @secure
     */
    getContractorById: (query: { uuid: string }, params: RequestParams = {}) =>
      this.request<ContractorDetailedResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/contractors`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name PutContractor
     * @summary Редактирование контрагента
     * @request PUT:/api/contractors/v1/external/contractors
     * @secure
     */
    putContractor: (
      query: { contractorId: string },
      data: Contractor,
      params: RequestParams = {}
    ) =>
      this.request<ContractorResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/contractors`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name PostContractor
     * @summary Сохранение контрагента
     * @request POST:/api/contractors/v1/external/contractors
     * @secure
     */
    postContractor: (data: Contractor, params: RequestParams = {}) =>
      this.request<ContractorResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/contractors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name DeleteContractor
     * @summary Удаление бенефициара
     * @request DELETE:/api/contractors/v1/external/contractors
     * @secure
     */
    deleteContractor: (query: { uuid: string }, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/contractors/v1/external/contractors`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник рублевых реквизитов
     * @name CreateRublePaymentDetails
     * @summary Сохранение рублевого реквизита
     * @request POST:/api/contractors/v1/external/ruble
     * @secure
     */
    createRublePaymentDetails: (
      data: RublePaymentDetailsRequest,
      params: RequestParams = {}
    ) =>
      this.request<RublePaymentDetailsResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/ruble`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник рублевых реквизитов
     * @name Update
     * @summary Редактирование рублевого реквизита
     * @request PUT:/api/contractors/v1/external/ruble/{detailsId}
     * @secure
     */
    update: (
      detailsId: string,
      data: RublePaymentDetailsRequest,
      params: RequestParams = {}
    ) =>
      this.request<RublePaymentDetailsResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/ruble/${detailsId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник рублевых реквизитов
     * @name Delete
     * @summary Удаление рублевого реквизита
     * @request DELETE:/api/contractors/v1/external/ruble/{detailsId}
     * @secure
     */
    delete: (detailsId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/contractors/v1/external/ruble/${detailsId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник рублевых реквизитов
     * @name FindByParams
     * @summary Получение списка рублевых реквизитов по ИНН или имени
     * @request GET:/api/contractors/v1/external/ruble/find
     * @secure
     */
    findByParams: (query?: { search?: string }, params: RequestParams = {}) =>
      this.request<RublePaymentDetailsResponse[], ErrorMessage>({
        path: `/api/contractors/v1/external/ruble/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник рублевых реквизитов
     * @name FindAllByParams
     * @summary Получение табличного списка рублевых реквизитов по ИНН или имени
     * @request GET:/api/contractors/v1/external/ruble/findAll
     * @secure
     */
    findAllByParams: (
      query?: { search?: string; size?: number; position?: number },
      params: RequestParams = {}
    ) =>
      this.request<RublePaymentDetailsListResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/ruble/findAll`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name GetAllCurrencyDetails
     * @summary Получение списка валютных реквизитов
     * @request GET:/api/contractors/v1/external/currency/currency_all
     * @secure
     */
    getAllCurrencyDetails: (
      query: { size: number; position?: number; searchText?: string },
      params: RequestParams = {}
    ) =>
      this.request<CurrencyPaymentDetailsListResponse, ErrorMessage>({
        path: `/api/contractors/v1/external/currency/currency_all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валютных реквизитов
     * @name GetCurrencyDetailsByContractorId
     * @summary Получение списка валютных реквизитов по контрагнету
     * @request GET:/api/contractors/v1/external/currency/contractor
     * @secure
     */
    getCurrencyDetailsByContractorId: (
      query: { contractorUuid: string },
      params: RequestParams = {}
    ) =>
      this.request<CurrencyPaymentDetailsResponse[], ErrorMessage>({
        path: `/api/contractors/v1/external/currency/contractor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контрагенты (раcширенные данные)
     * @name GetContragentPage
     * @summary Получение списка контрагентов
     * @request GET:/api/contractors/v1/external/contragents
     * @secure
     */
    getContragentPage: (
      query: { page?: number; size?: number; id?: string[]; clientId: string },
      params: RequestParams = {}
    ) =>
      this.request<ContragentPage, ErrorMessage>({
        path: `/api/contractors/v1/external/contragents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контрагенты (раcширенные данные)
     * @name GetContragentTypes
     * @summary Получение списка типов контрагентов
     * @request GET:/api/contractors/v1/external/contragents/types
     * @secure
     */
    getContragentTypes: (params: RequestParams = {}) =>
      this.request<ContragentType, ErrorMessage>({
        path: `/api/contractors/v1/external/contragents/types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контрагенты (раcширенные данные)
     * @name GetContragentPrefCommnMethods
     * @summary Получение списка предпочитаемых способов связи контрагента
     * @request GET:/api/contractors/v1/external/contragents/pref-commn-methods
     * @secure
     */
    getContragentPrefCommnMethods: (params: RequestParams = {}) =>
      this.request<ContragentPrefCommnMethod, ErrorMessage>({
        path: `/api/contractors/v1/external/contragents/pref-commn-methods`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name FindContractors
     * @summary Поиск контрагентов по имени или инн
     * @request GET:/api/contractors/v1/external/contractors/find
     * @secure
     */
    findContractors: (query: { search: string }, params: RequestParams = {}) =>
      this.request<ContractorResponse[], ErrorMessage>({
        path: `/api/contractors/v1/external/contractors/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник контрагентов
     * @name GetAll
     * @summary Получение списка контрагентов
     * @request GET:/api/contractors/v1/external/contractors/all
     * @secure
     */
    getAll: (
      query: { size: number; page: number },
      params: RequestParams = {}
    ) =>
      this.request<ContractorWithAccountsResponse[], ErrorMessage>({
        path: `/api/contractors/v1/external/contractors/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контрагенты (раcширенные данные)
     * @name GetClientDelegates
     * @summary Получение списка делегатов клиента
     * @request GET:/api/contractors/v1/external/client-delegates
     * @secure
     */
    getClientDelegates: (
      query: { id?: string[]; clientId: string; isNotActive?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ClientDelegateData, ErrorMessage>({
        path: `/api/contractors/v1/external/client-delegates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
